import { Fragment, type ReactNode } from 'react';
import { tableExportSplitCodes } from '@goyone/shared';

/**
 * رقمُ مستندٍ أو قيدٍ يُعرض كما كُتب: «INV-2026-0120».
 *
 * في سطرٍ عربيّ تقلب خوارزميّةُ الاتجاه الرمزَ اللاتينيّ («-INV-2026 0120»)،
 * ويكسره المتصفّح عند شَرطته على سطرين. العزلُ اتجاهًا لاتينيًّا (`bdi`) يحفظ
 * ترتيبه، و`.code` يمنع كسره ويصفّ أرقامه — في الجداول وخارجها.
 */
export function Code({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <bdi dir="ltr" className={className ? `code ${className}` : 'code'}>
      {children}
    </bdi>
  );
}

/**
 * نصٌّ عربيٌّ فيه أرقامُ مستندات: «تحصيل PAY-2026-0137 للفاتورة INV-2026-0120».
 * النصُّ يلتفّ كعادته، وكلُّ رمزٍ فيه معزولٌ لا يُكسر (`<Code>`).
 */
export function CodeText({ text }: { text: string | null | undefined }) {
  if (!text) return null;
  return (
    <>
      {tableExportSplitCodes(text).map((part, i) =>
        part.code ? <Code key={i}>{part.text}</Code> : <Fragment key={i}>{part.text}</Fragment>,
      )}
    </>
  );
}
